import {
  takeLatest,
  select,
  fork,
  call,
  put,
} from 'redux-saga/effects';
import { ERROR_PASS_REQUEST, ERROR_UPDATE_REQUEST } from '@/action-types/error';
import {
  GRAMMAR_SET_STATE_REQUEST,
  GRAMMAR_SET_STATE_SUCCESS,
} from '@/action-types/grammar';
import {
  grammarSearch,
  topListGet,
  fullListGet,
} from '@/api/grammar';

interface GrammarParams {
  state: {
    isOpen: boolean;
    activeTab: string;
    activeId?: string;
    searchString?: string;
  };
}

const defaultState = {
  activeId: null,
  activeTab: '',
  isOpen: false,
  searchResult: {
    fullList: [],
    searchList: [],
    topList: [],
  },
  searchString: '',
};

export function* searchByString(params: GrammarParams) {
  const state = yield select();

  try {
    const response = yield call(grammarSearch, params.state.searchString);

    yield put({
      type: GRAMMAR_SET_STATE_SUCCESS,
      data: {
        ...defaultState,
        ...(state.book.grammar || {}),
        activeId: null,
        searchResult: {
          ...(state.book.grammar.searchResult || {}),
          searchList: response?.data?.getCourseElementTags || [],
        },
        searchString: params.state.searchString,
      },
    });
  } catch (e) {
    yield put({ type: ERROR_PASS_REQUEST, error: e, tags: ['logic', 'searchByString'] });
    yield put({ type: ERROR_UPDATE_REQUEST, errorData: e });
  }
}

export function* searchByTab(params: GrammarParams) {
  const state = yield select();

  let elements: any = state.book.grammar?.searchResult?.[params.state.activeTab] || [];

  try {
    if (!elements.length && params.state.isOpen) {
      if (params.state.activeTab === 'topList') {
        const response = yield call(topListGet);
        elements = response?.data?.getCourseElementTags;
      }

      if (params.state.activeTab === 'fullList') {
        const response = yield call(fullListGet);
        elements = response?.data?.getCourseElementTags;
      }
    }
  } catch (e) {
    yield put({ type: ERROR_PASS_REQUEST, error: e, tags: ['logic', 'searchByTab'] });
    yield put({ type: ERROR_UPDATE_REQUEST, errorData: e });
  }

  yield put({
    type: GRAMMAR_SET_STATE_SUCCESS,
    data: {
      activeTab: params.state.activeTab,
      activeId: null,
      isOpen: params.state.isOpen,
      searchResult: {
        ...(state.book.grammar.searchResult || {}),
        [params.state.activeTab]: elements || [],
        searchList: [],
      },
      searchString: '',
    },
  });
}

export function* searchById(params: GrammarParams) {
  const state = yield select();

  yield put({
    type: GRAMMAR_SET_STATE_SUCCESS,
    data: {
      ...defaultState,
      ...(state.book.grammar || {}),
      activeId: params.state.activeId,
    },
  });
}

export function* togglePopup(params: GrammarParams) {
  const state = yield select();

  yield put({
    type: GRAMMAR_SET_STATE_SUCCESS,
    data: {
      ...defaultState,
      ...(state.bookgrammar || {}),
      isOpen: params.state.isOpen,
    },
  });
}

export function* setState(params: GrammarParams) {
  if (params.state.searchString) {
    yield fork(searchByString, params);
  } else if (params.state.activeTab) {
    yield fork(searchByTab, params);
  } else if (params.state.activeId) {
    yield fork(searchById, params);
  } else {
    yield fork(togglePopup, params);
  }
}

export default function* grammarSaga() {
  yield takeLatest<{ type: string; } & any>(GRAMMAR_SET_STATE_REQUEST, setState);
}
